<template>
  <div class="main">
    <div style="padding: 13px 12px;background-color: #ffffff;">
      <div class="flex-between">
        <div style="font-size: 18px;font-weight: 600;">下班拼车统计<van-icon name="checked" color="#FEB013"/></div>
        <div style="color: #999999;font-size: 12px;">数据更新至{{$moment(new Date()).format('YYYY年MM月DD日')}}</div>
      </div>
      <div class="flex-between" style="margin-top: 20px;">
        <van-button
          type="primary"
          icon="arrow-down"
          icon-position="right"
          size="small"
          @click="showPicker = true"
        >{{currentDate}}</van-button>
        <van-popup v-model="showPicker" position="bottom">
            <van-datetime-picker
                type="year-month"
                title="选择年月日"
                :min-date="minDate"
                :max-date="maxDate"
                :formatter="formatter"
                @confirm="selectDate"
                @cancel="showPicker = false"
            />
        </van-popup>
        <div style="font-size: 12px;">总拼车(次)： 
          <a style="font-size: 18px;font-weight: 600;">{{Count}}</a>
        </div>
      </div>    
    </div>
    <div v-for="(item, key) in tableList" :key="key" class="listClass flex-between">
      <div class="flex">
        <div class="route">{{item.CarRoute}}路线</div>
        <div style="margin: 0 10px ;">{{item.Name}}</div>
      </div>
      <div style="color: #999999;font-size: 14px;">{{item.UpDateTime}}</div>
    </div>
    <div class="company">由营销信息部提供技术支持</div>  
  </div>
</template>

<script>
export default {
  data() {
    return {
      form: {
        Name: '',
        UserId: '',
        Phone: '',
        Message: '',
        Status: false
      },
      tableList: [],
      Count: 0,
      showPicker: false,
      minDate: new Date(2022, 0, 1),
      maxDate: new Date(),
      currentDate: this.$moment(new Date()).format('YYYY-MM')
    }
  },
  mounted() {
    // const test = {"errno":0,"data":{"errcode":0,"errmsg":"ok","userid":"2017551","name":"吴昌悦","department":[2267],"position":"软件开发工程师","mobile":"15812615614","gender":"1","email":"wuchangyue@jianlianmed.com","avatar":"http://wework.qpic.cn/wwhead/duc2TvpEgSTPk74IwG7Bs6QbDoJ0d3L4YVkyYficZxxcflGOZ1LUI81OkNwXIicNlbdduibhLKxSGc/0","status":1,"isleader":0,"extattr":{"attrs":[{"name":"英文名","value":"","type":0,"text":{"value":""}},{"name":"工号","value":"2017551","type":0,"text":{"value":"2017551"}},{"name":"身份证","value":"","type":0,"text":{"value":""}}]},"english_name":"","telephone":"020-88985632","enable":1,"hide_mobile":0,"order":[0],"external_profile":{"external_attr":[],"external_corp_name":""},"main_department":2267,"qr_code":"https://open.work.weixin.qq.com/wwopen/userQRCode?vcode=vc5b6c10860443246c","alias":"","is_leader_in_dept":[0],"address":"","thumb_avatar":"http://wework.qpic.cn/wwhead/duc2TvpEgSTPk74IwG7Bs6QbDoJ0d3L4YVkyYficZxxcflGOZ1LUI81OkNwXIicNlbdduibhLKxSGc/100","direct_leader":[],"openid":"o_Td1s7gCLuLiZITNxC3ApjOLC7U","access_token":"hER4OJaZReJSc_9Mi6NCJTXyliK2QkEDuj0ruK4CsiFGKySTq81qK6AsR7GqX6bROcq28TctrjQqtXheO0mKenvkX6pu6kkuP9cSO51qDnBHwnOThgl4thnSeAFw_PlA0aUdAX3tE5yPHs3IIgOwB4bEc6yFKchMe7tjjaACla90dBlIe8j8JuSB-SOLpoWVXMI36ulQW7uRs6VXRfH57w"}}
    // this.WXInfo = test.data
    this.WXInfo = JSON.parse(localStorage.getItem('userinfo')).data
    this.form.Name = this.WXInfo.name
    this.form.UserId = this.WXInfo.userid
    this.form.Phone = this.WXInfo.mobile
    this.getData()
  },
  methods: {
    async getData () {
      const result = await this.getTravelList()
      if (result.success) {
        result.data.forEach(ele => {
          ele.UpDateTime = this.$moment(ele.UpDateTime).format('YYYY-MM-DD HH:mm:ss')
        })
        this.tableList = result.data
        this.Count = result.count
      } else {
        this.$toast(result.message)
      }
    },
    formatter(type, val) {
      if (type === 'year') {
        return `${val}年`
      } else if (type === 'month') {
        return `${val}月`
      }
      return val
    },
    selectDate (value) {
      this.currentDate = this.$moment(value).format('YYYY-MM')
      this.showPicker = false
      this.getData()
    },
    getTravelList () {
      return this.$request({
        url: this.$api.getTravelList,
        method: 'GET',
        params: {
          CarName: this.form.Name,
          likeTime: this.currentDate,
          Status: '已发车'
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
  .main {
    background-color:#F5F5F5;;
  }
  /deep/.van-cell {
    background-color: #F5F5F5;
    margin: 8px 0;
    border-radius: 4px;
    padding: 16px 12px;
    font-size: 16px;
  }
  .listClass {
    margin: 8px 12px;
    padding: 10px 12px;
    border-radius: 4px;
    background-color: #ffffff;
  }
  .route {
    border: 1px solid;
    border-radius: 4px;
    font-size: 14px;
    padding: 2px 4px;
  }
  .flex-between {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .flex {
    display: flex;
    align-items: center;
  }
  .company {
    text-align: center;
    color: #999999;
    font-size: 12px;
    margin-bottom: 10px;
  }  
</style>
